import * as ContextMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { Pencil2Icon } from '@radix-ui/react-icons';
import { Link } from 'react-router';

import { ContextMenuItem } from '../../primitives/context-menu';

import type { JSX } from 'react';

interface ContextMenuItemEditProps extends React.ComponentPropsWithoutRef<
  typeof ContextMenuPrimitive.Item
> {
  icon?: JSX.Element;
  navLink?: {
    to: string;
  };
  text?: string;
}

export function ContextMenuItemNavigate({
  icon = <Pencil2Icon className="size-4" />,
  id,
  navLink,
  text = 'Editar',
  ...props
}: ContextMenuItemEditProps) {
  if (navLink) {
    return (
      <ContextMenuItem asChild template="grid-icon-content">
        <Link className="rounded-3xl" id={id} to={navLink?.to}>
          <div className="flex justify-center">{icon}</div>
          <span>{text}</span>
        </Link>
      </ContextMenuItem>
    );
  }

  return (
    <ContextMenuItem id={id} template="grid-icon-content" {...props}>
      <div className="flex justify-center">{icon}</div>
      <span>{text}</span>
    </ContextMenuItem>
  );
}
